var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-sortable",
            { attrs: { tag: "w-list", items: _vm.value.OrderColumns } },
            _vm._l(_vm.value.OrderColumns, function (sorting, i) {
              return _c(
                "w-list-item",
                { key: i, attrs: { "show-handle": "" } },
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.getSortingName(sorting))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.edit"),
                              expression: "$ct('common.edit')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.editSorting(sorting)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "pen" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.delete"),
                              expression: "$ct('common.delete')",
                            },
                          ],
                          staticClass: "danger",
                          on: {
                            click: function ($event) {
                              return _vm.removeSorting(i)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "w-list",
            [
              _vm.value.OrderColumns.length == 0
                ? _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", [
                        _vm._v(_vm._s(_vm.$ct("no-sorted-columns"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addSorting()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(" " + _vm._s(_vm.$ct("add-sorting")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditSorting != null } },
        [
          _vm.toEditSorting
            ? _c("app-sorting-edit", {
                attrs: {
                  model: _vm.model,
                  value: _vm.toEditSorting,
                  browse: _vm.browse,
                },
                on: {
                  input: function ($event) {
                    return _vm.editSortingConfirm($event)
                  },
                  close: function ($event) {
                    _vm.toEditSorting = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }